import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const StyledHeaderNotificationItem = styled.div`
  position: relative;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  width: 100%;
  overflow: hidden;

  .icon svg {
    cursor: auto;
  }

  .text {
    padding-left: 12px;

    p {
      color: ${ThemePrisma.colors.gray[7]};
      font-family: ${ThemePrisma.fonts.body.s.midContrast.fontFamily};
      font-size: ${ThemePrisma.fonts.body.s.midContrast.fontSize};
      font-weight: ${ThemePrisma.fonts.body.s.midContrast.fontWeight};
      letter-spacing: ${ThemePrisma.fonts.body.s.midContrast.letterSpacing};
      line-height: ${ThemePrisma.fonts.body.s.midContrast.lineHeight};

      &.date {
        color: ${ThemePrisma.colors.gray[5]};
      }
    }
  }

  .action {
    margin-left: auto;
  }

  &.unchecked {
    background-color: rgb(33 134 235 / 10%);
  }

  &.info {
    .icon svg {
      color: ${ThemePrisma.colors.blue[4]};
    }

    &::before {
      box-shadow: ${ThemePrisma.colors.blue[4]} 8px 0px inset;
    }
  }

  &.warning {
    .icon svg {
      color: ${ThemePrisma.colors.yellow[4]};
    }

    &::before {
      box-shadow: ${ThemePrisma.colors.yellow[4]} 8px 0px inset;
    }
  }

  &.error {
    .icon svg {
      color: ${ThemePrisma.colors.red[5]};
    }

    &::before {
      box-shadow: ${ThemePrisma.colors.red[5]} 8px 0px inset;
    }
  }

  &.success {
    .icon svg {
      color: ${ThemePrisma.colors.green[5]};
    }

    &::before {
      box-shadow: ${ThemePrisma.colors.green[5]} 8px 0px inset;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 5%;
    height: 100%;
    border-radius: 1.5px;
  }
`;
